// @ts-check
import { lineOfBusinessPlannerMainQuery } from "src/allocation/graphql/allocation.graphql";
import {
  requestorForecastMainQueryPart1,
  requestorForecastMainQueryPart2,
  requestorForecastMainQueryForGroupPart1,
  requestorForecastMainQueryForGroupPart2,
  approverForecastMainQueryPart1,
  approverForecastMainQueryPart2,
  approverConstraintsMainQueryPart1,
  approverConstraintsMainQueryPart2,
  approverPlannerMainQueryPart1,
  approverPlannerMainQueryPart2,
  requestorPlannerMainQueryPart1,
  requestorPlannerMainQueryPart2,
} from "src/allocation/graphql/dynamicMacroAllocationQueries.graphql";

import { FORECAST } from "../pageModes";
import { CURRENT_GROUP_ONLY_VIEW, GROUPED_BY_CONSTRAINTS } from "../viewModes";

const selectQuery = (
  pageMode,
  viewMode,
  isRequestorGroup,
  isLineOfBusinessGroup
) => {
  if (pageMode === FORECAST) {
    if (isRequestorGroup) {
      if (viewMode === CURRENT_GROUP_ONLY_VIEW) {
        return {
          part1: requestorForecastMainQueryForGroupPart1,
          part2: requestorForecastMainQueryForGroupPart2,
        };
      }

      return {
        part1: requestorForecastMainQueryPart1,
        part2: requestorForecastMainQueryPart2,
      };
    }

    if (viewMode === GROUPED_BY_CONSTRAINTS) {
      return {
        part1: approverConstraintsMainQueryPart1,
        part2: approverConstraintsMainQueryPart2,
      };
    }

    return {
      part1: approverForecastMainQueryPart1,
      part2: approverForecastMainQueryPart2,
    };
  }

  if (isRequestorGroup) {
    return {
      part1: requestorPlannerMainQueryPart1,
      part2: requestorPlannerMainQueryPart2,
    };
  }

  if (isLineOfBusinessGroup) {
    return {
      part1: lineOfBusinessPlannerMainQuery,
      part2: undefined,
    };
  }

  return {
    part1: approverPlannerMainQueryPart1,
    part2: approverPlannerMainQueryPart2,
  };
};

export { selectQuery };
